var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7386 6.23596H16.8752L13.7386 3.09939V6.23596ZM17.3811 7.45012H12.1198V2.59349H6.04898V6.74186L4.43011 5.12298V0.974609H13.8398L19 6.13478V17.9728H4.43011V10.9914L6.04898 12.6103V16.3539H17.3811V7.45012ZM4.24462 5.62888L10.3322 11.7165L8.08946 13.9593L2.00179 7.87171L4.24462 5.62888ZM1.52119 7.39111L0.239561 6.36304C-0.171431 5.95201 -0.0112023 5.07867 0.39979 4.66767L1.04058 4.02688C1.45157 3.61589 2.23159 3.45566 2.64258 3.86669L3.76398 5.14832L1.52119 7.39111ZM11.2988 15.241L8.57006 14.44L10.8129 12.1972L11.5619 14.9779L11.2988 15.241Z",
    fill: "#8F96A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.097cbac46f397156bd6d7372446fca0a.svg";
export { ForwardRef as ReactComponent };